import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatFormFieldModule, MatButtonModule, MatInputModule, MatRippleModule, MatExpansionModule, MatCardModule, MatListModule, MatIconModule, MatSidenavModule, MatToolbarModule} from '@angular/material';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './pages/home/home.component';
import { FitterComponent } from './pages/fitter/fitter.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FitterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatRippleModule,
    MatExpansionModule,
    FormsModule,
    MatCardModule,
    MatListModule,
    FlexLayoutModule,
    MatIconModule, 
    MatSidenavModule, 
    MatToolbarModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
